/* eslint-disable */
// Deliberate and identical ES5 across the 4 repositories.
(function () {
  if (window.FinteraHelpCard) return;

  var CARD_ID = "fintera-help-card";
  var COPY_FEEDBACK_MS = 2000;
  var feedbackTimer = null;

  function closest(el, selector) {
    while (el && el.nodeType === 1) {
      if ((el.matches || el.msMatchesSelector).call(el, selector)) return el;
      el = el.parentNode;
    }
    return null;
  }

  function card() {
    return document.getElementById(CARD_ID);
  }

  function isOpen() {
    var el = card();
    return !!el && !el.hidden;
  }

  function setExpanded(value) {
    var toggles = document.querySelectorAll("[data-help-card-toggle]");
    for (var i = 0; i < toggles.length; i++) {
      toggles[i].setAttribute("aria-expanded", value ? "true" : "false");
    }
  }

  function resetFeedback() {
    clearTimeout(feedbackTimer);
    var el = card();
    var status = el && el.querySelector("[data-help-card-copy-status]");
    if (status) {
      status.textContent = "";
      status.className = status.className.replace(/\s*is-error/g, "");
    }
  }

  function open() {
    var el = card();
    if (!el) return;
    el.hidden = false;
    setExpanded(true);
    el.focus();
  }

  function close(returnFocus) {
    var el = card();
    if (!el || el.hidden) return;
    el.hidden = true;
    setExpanded(false);
    resetFeedback();
    if (returnFocus) {
      var toggle = document.querySelector("[data-help-card-toggle]");
      if (toggle) toggle.focus();
    }
  }

  function showFeedback(ok) {
    var el = card();
    var status = el && el.querySelector("[data-help-card-copy-status]");
    if (!status) return;
    resetFeedback();
    status.textContent = ok ? "Copiado!" : "Não foi possível copiar";
    if (!ok) status.className += " is-error";
    feedbackTimer = setTimeout(resetFeedback, COPY_FEEDBACK_MS);
  }

  function legacyCopy(text) {
    var area = document.createElement("textarea");
    area.value = text;
    area.setAttribute("readonly", "");
    area.style.position = "fixed";
    area.style.opacity = "0";
    document.body.appendChild(area);
    area.select();
    var ok = false;
    try { ok = document.execCommand("copy"); } catch (e) { ok = false; }
    document.body.removeChild(area);
    return ok;
  }

  function copy(text) {
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text).then(
        function () { showFeedback(true); },
        function () { showFeedback(legacyCopy(text)); }
      );
    } else {
      showFeedback(legacyCopy(text));
    }
  }

  document.addEventListener("click", function (event) {
    var target = event.target;

    if (closest(target, "[data-help-card-toggle]")) {
      event.preventDefault();
      if (isOpen()) { close(false); } else { open(); }
      return;
    }

    if (closest(target, "[data-help-card-close]")) {
      event.preventDefault();
      close(true);
      return;
    }

    var copyButton = closest(target, "[data-help-card-copy]");
    if (copyButton) {
      event.preventDefault();
      copy(copyButton.getAttribute("data-help-card-copy"));
      return;
    }

    if (isOpen() && !closest(target, "#" + CARD_ID)) close(false);
  });

  document.addEventListener("keydown", function (event) {
    if ((event.key === "Escape" || event.key === "Esc") && isOpen()) close(true);
  });

  var navigationEvents = [
    "turbolinks:before-visit", "turbolinks:before-cache",
    "turbo:before-visit", "turbo:before-cache"
  ];
  for (var i = 0; i < navigationEvents.length; i++) {
    document.addEventListener(navigationEvents[i], function () { close(false); });
  }

  if (window.jQuery) {
    window.jQuery(document).on("pjax:send", function () { close(false); });
  }

  window.FinteraHelpCard = { open: open, close: close };
})();
